import VacancyBuilderFormWrapper from './VacancyBuilderFormWrapper.component';

export default VacancyBuilderFormWrapper;
